export default __webpack_public_path__ + "static/media/grayCircle.44c0e199.svg";